<template>
  <v-dialog v-model="progress" persistent width="300">
    <v-card color="teal darken-5" dark>
      <v-card-text class="pt-2">
        <div>
          <span class="title white--text py-0 my-0">Please wait</span>
        </div>
        <span class="caption py-0 my-0">Loading...</span>

        <v-progress-linear indeterminate color="white" class="mt-5 elevation-20"></v-progress-linear>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
export default {
  computed: {
    ...mapState(["progress"])
  }
};
</script>